import { DatePicker as AntDatePicker, ConfigProvider } from 'antd';
import type { DatePickerProps as AntdDatePickerProps } from 'antd/es/date-picker';

import FieldsContainer from '../fields-container';
import { defaultInputTheme } from '../ourConfigs';

import css from './styles.module.scss';

export interface IDatePickerProps extends AntdDatePickerProps {
  label?: string;
  requiredTag?: boolean;
  error?: string;
}

function DatePicker({ requiredTag, label, error, ...props }: IDatePickerProps) {
  return (
    <FieldsContainer error={error} requiredTag={requiredTag} label={label}>
      <ConfigProvider theme={defaultInputTheme}>
        <div className={css.container}>
          <AntDatePicker
            style={{ width: '100%' }}
            status={error ? 'error' : ''}
            format="YYYY-MM-DD"
            {...props}
          />
        </div>
      </ConfigProvider>
    </FieldsContainer>
  );
}

export default DatePicker;
